/** Read human-readable string filters and older JSON-encoded query values. */
export function decodeQueryValue<T>(raw: string | null, initial: T): T {
  if (raw === null) return initial;
  try {
    const parsed: unknown = JSON.parse(raw);
    if (Array.isArray(initial)) return Array.isArray(parsed) && parsed.length > 0 && parsed.every((item) => typeof item === "string") ? parsed as T : initial;
    if (typeof parsed === typeof initial) return parsed as T;
  } catch { /* Plain string query parameters are supported below. */ }
  return typeof initial === "string" ? raw as T : initial;
}
export function encodeQueryValue<T>(value: T) { return typeof value === "string" ? value : JSON.stringify(value); }
